<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <base-items store-module="itemgroups" @items="items = $event" @state="state = $event">
          <v-card :loading="state.loading">
            <v-card-title>
              <v-row align="center">
                <v-col cols="auto" class="headline">
                  Item groups
                </v-col>
                <v-col>
                  <v-btn color="primary" fab depressed small @click="openItemGroupForm(createNewItemGroup())" :disabled="state.working"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-data-table
                :headers="tableHeaders"
                :items="sortedItems"
                :items-per-page="-1"
                class="itemgroups-table"
                must-sort
                sort-by="name"
                @click:row="openItemGroupForm({...$event})"
              >
                <template v-slot:item.vat="{ item }">
                  <span>{{ item.vat }}%</span>
                </template>
                <template v-slot:item.first_state="{ item }">
                  <span>{{ item.first_state ? item.first_state : 'NEW' }}</span>
                </template>
                <template v-slot:item.id="{ item }">
                  <span><v-btn text icon @click.stop="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn></span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </base-items>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <base-items store-module="tabs" @items="tabs = $event" @state="tabsState = $event">
          <v-card :loading="tabsState.loading" class="mb-8">
            <v-card-title>
              <v-row align="center">
                <v-col cols="auto" class="headline">
                  Tabs
                </v-col>
                <v-col>
                  <v-btn color="primary" fab depressed small @click="openTabForm(createNewTab())" :disabled="tabsState.working || tabs.length >= 8"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text v-if="tabs.length >= 8">
              <div>8 is the maximum number of tabs</div>
            </v-card-text>

            <v-card-text>
              Select which tab each item group will appear under in the app
              <draggable v-model="sortedTabs" ghost-class="tab-ghost" handle=".handle">
                <div class="d-flex pa-1 align-center" v-for="tab in sortedTabs" :key="tab.id">
                  <div class="flex-grow-1">
                    <div class="title">
                      {{tab.name}}
                    </div>
                    <div class="caption mx-4">
                      Item groups
                    </div>
                    <v-row class="mx-2">
                      <v-col
                        cols="auto"
                        class="py-0"
                        v-for="itemgroup in sortedItems"
                        :key="tab.id + '_' + itemgroup.id"
                      >
                        <v-checkbox
                          class="mt-1"
                          :label="itemgroup.name"
                          :value="tab.itemgroupIds"
                          :value-comparator="(val) => (val || []).indexOf(itemgroup.id) != -1"
                          @change="onTabItemgroupChange(tab, itemgroup)"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="">
                    <v-btn text icon class="mx-5" @click.stop="deleteTab(tab)"><v-icon>mdi-delete</v-icon></v-btn>
                  </div>
                  <div class="handle">
                    <v-icon>mdi-drag-horizontal-variant</v-icon>
                  </div>
                </div>
              </draggable>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="tabsSave" :disabled="tabsState.loading || tabs.length == 0" :loading="tabsState.saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </base-items>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <base-items store-module="queuegroups" @items="queuegroups = $event" @state="queuegroupsState = $event">
          <v-card :loading="queuegroupsState.loading" class="mb-8">
            <v-card-title>
              <v-row align="center">
                <v-col cols="auto" class="headline">
                  Queue Groups
                </v-col>
                <v-col>
                  <v-btn color="primary" fab depressed small @click="openQueueGroupForm(createNewQueueGroup())" :disabled="queuegroupsState.working || queuegroups.length >= 8"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              Select which item groups will be joined into queue groups in the app
              <draggable v-model="sortedQueueGroups" ghost-class="queuegroup-ghost" handle=".handle">
                <div class="d-flex pa-1 align-center" v-for="queuegroup in sortedQueueGroups" :key="queuegroup.id">
                  <div class="flex-grow-1">
                    <div class="title">
                      {{queuegroup.name}}
                    </div>
                    <div class="caption mx-4">
                      Item groups
                    </div>
                    <v-row class="mx-2">
                      <v-col
                        cols="auto"
                        class="py-0"
                        v-for="itemgroup in sortedItems"
                        :key="queuegroup.id + '_' + itemgroup.id"
                      >
                        <v-checkbox
                          class="mt-1"
                          :label="itemgroup.name"
                          :value="queuegroup.itemgroupIds"
                          :value-comparator="(val) => (val || []).indexOf(itemgroup.id) != -1"
                          @change="onQueueGroupItemgroupChange(queuegroup, itemgroup)"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="">
                    <v-btn text icon class="mx-5" @click.stop="deleteQueueGroup(queuegroup)"><v-icon>mdi-delete</v-icon></v-btn>
                  </div>
                  <div class="handle">
                    <v-icon>mdi-drag-horizontal-variant</v-icon>
                  </div>
                </div>
              </draggable>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="queueGroupsSave" :disabled="queuegroupsState.loading || queuegroups.length == 0" :loading="queuegroupsState.saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </base-items>
      </v-col>
    </v-row>

    <v-dialog :value="editItemGroup" max-width="600px" persistent>
      <item-group-form ref="itemGroupForm" :item="editItemGroup" @submit="submit" @cancel="closeItemGroupForm"/>
    </v-dialog>

    <v-dialog :value="editTab" max-width="600px" persistent>
      <tab-form ref="tabForm" :item="editTab" @submit="tabSubmit" @cancel="closeTabForm"/>
    </v-dialog>

    <v-dialog :value="editQueueGroup" max-width="600px" persistent>
      <queue-group-form ref="queueGroupForm" :item="editQueueGroup" @submit="queueGroupSubmit" @cancel="closeQueueGroupForm"/>
    </v-dialog>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import {BaseItems} from 'dync-baseitem';
import ItemGroupForm from '../components/ItemGroupForm.vue';
import TabForm from '../components/TabForm.vue';
import QueueGroupForm from '../components/QueueGroupForm.vue';

export default {
  data () {
    return {
      editItemGroup: null,
      editTab: null,
      editQueueGroup: null,
      items: [],
      state: {},
      tabs: [],
      tabsState: {},
      queuegroups: [],
      queuegroupsState: {},
      tableHeaders: [
        {
          text: 'Item group name',
          value: 'name'
        },
        {
          text: 'Account number',
          value: 'account_number'
        },
        {
          text: 'Cost Center',
          value: 'cost_center'
        },
        {
          text: 'First State',
          value: 'first_state'
        },
        {
          text: 'Vat %',
          value: 'vat'
        },
        {
          text: 'Remove',
          value: 'id',
          sortable: false
        }
      ]
    };
  },
  computed: {
    sortedItems () {
      var _items = this.items.slice(0);
      _items.sort((a, b) => {
        if (a.created_at > b.created_at) {
          return 1;
        } else if (a.created_at < b.created_at) {
          return -1;
        } else {
          return 0
        }
      });
      return _items;
    },
    sortedTabs: {
      get () {
        var tabs = this.tabs.slice(0);
        tabs.map((tab) => {
          tab.itemgroupIds = tab.itemgroupIds || [];
        });
        tabs.sort((a, b) => (a.order || 0) - (b.order || 0));
        return tabs;
      },
      set (tabs) {
        const reorderedTabs = tabs.map((t, i) => Object.assign({}, t, {order: i}));
        const reorderedTabsPayload = reorderedTabs.map(t => ({id: t.id, order: t.order}));

        this.$store.commit('tabs/replaceItems', reorderedTabs);
        this.$store.dispatch('tabs/updateItems', reorderedTabsPayload).then(() => {
        }).catch(() => {
          this.$store.commit('tabs/replaceItems', tabs);
          this.$snackbar({message: 'Could not save tab order.', theme: 'error'});
        });
      }
    },
    sortedQueueGroups: {
      get () {
        var queuegroups = this.queuegroups.slice(0);
        queuegroups.map((queuegroup) => {
          queuegroup.itemgroupIds = queuegroup.itemgroupIds || [];
        });
        queuegroups.sort((a, b) => (a.order || 0) - (b.order || 0));
        return queuegroups;
      },
      set (queuegroups) {
        const reorderedQueueGroups = queuegroups.map((t, i) => Object.assign({}, t, {order: i}));
        const reorderedQueueGroupsPayload = reorderedQueueGroups.map(t => ({id: t.id, order: t.order}));

        this.$store.commit('queuegroups/replaceItems', reorderedQueueGroups);
        this.$store.dispatch('queuegroups/updateItems', reorderedQueueGroupsPayload).then(() => {
        }).catch(() => {
          this.$store.commit('queuegroups/replaceItems', queuegroups);
          this.$snackbar({message: 'Could not save queue group order.', theme: 'error'});
        });
      }
    }
  },
  methods: {
    getNextOrderNumber(items) {
      var lastItem = items[items.length-1];
      if (lastItem && lastItem.order != undefined) {
        return lastItem.order + 1;
      } else {
        return 1;
      }
    },
    submit (payload) {
      payload.vat = Number(payload.vat);
      if (payload.id) {
        this.$store.dispatch('itemgroups/updateItem', payload).then(() => {
          this.$snackbar({message: 'Item group updated!', theme: 'success'})
          this.closeItemGroupForm();
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not update item group', theme: 'error'})
        });
      } else {
        this.$store.dispatch('itemgroups/createItem', payload).then(() => {
          this.$snackbar({message: 'Item group created!', theme: 'success'})
          this.closeItemGroupForm();
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not create item group', theme: 'error'})
        });
      }
    },
    deleteItem (item) {
      this.$confirm({
        title: `Are you sure you want to delete item group "${item.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.$store.dispatch('itemgroups/deleteItem', item.id).then(() => {
          this.$snackbar({message: 'Item group deleted', theme: 'success'})
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not delete item group', theme: 'error'})
        });
      });
    },
    tabSubmit (payload) {
      this.$store.dispatch('tabs/createItem', payload).then(() => {
        this.$snackbar({message: 'Tab created!', theme: 'success'});
        this.closeTabForm();
      }).catch((error) => {
        console.error(error);
        this.$snackbar({message: 'Could not create tab', theme: 'error'})
      });
    },
    tabsSave () {
      var tabs = this.sortedTabs.slice(0);
      var payload = tabs.map(t => ({id: t.id, itemgroupIds: t.itemgroupIds}));
      this.$store.dispatch('tabs/updateItems', payload).then(() => {
      }).catch(() => {
        this.$snackbar({message: 'Could not save item group selection', theme: 'error'});
      });
    },
    onTabItemgroupChange (tab, itemgroup) {
      if (tab.itemgroupIds.indexOf(itemgroup.id) != -1) {
        tab.itemgroupIds.splice(tab.itemgroupIds.indexOf(itemgroup.id), 1);
      } else {
        tab.itemgroupIds.push(itemgroup.id);
      }
    },
    deleteTab (item) {
      this.$confirm({
        title: `Are you sure you want to delete tab "${item.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.$store.dispatch('tabs/deleteItem', item.id).then(() => {
          this.$snackbar({message: 'Tab deleted', theme: 'success'})
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not delete tab', theme: 'error'})
        });
      });
    },
    queueGroupSubmit (payload) {
      this.$store.dispatch('queuegroups/createItem', payload).then(() => {
        this.$snackbar({message: 'Queue group created!', theme: 'success'});
        this.closeQueueGroupForm();
      }).catch((error) => {
        console.error(error);
        this.$snackbar({message: 'Could not create queue group', theme: 'error'})
      });
    },
    queueGroupsSave () {
      var queuegroups = this.sortedQueueGroups.slice(0);
      var payload = queuegroups.map(t => ({id: t.id, itemgroupIds: t.itemgroupIds}));
      this.$store.dispatch('queuegroups/updateItems', payload).then(() => {
      }).catch(() => {
        this.$snackbar({message: 'Could not save item group selection', theme: 'error'});
      });
    },
    onQueueGroupItemgroupChange (queuegroup, itemgroup) {
      if (queuegroup.itemgroupIds.indexOf(itemgroup.id) != -1) {
        queuegroup.itemgroupIds.splice(queuegroup.itemgroupIds.indexOf(itemgroup.id), 1);
      } else {
        queuegroup.itemgroupIds.push(itemgroup.id);
      }
    },
    deleteQueueGroup (item) {
      this.$confirm({
        title: `Are you sure you want to delete queue group "${item.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.$store.dispatch('queuegroups/deleteItem', item.id).then(() => {
          this.$snackbar({message: 'Queue group deleted', theme: 'success'})
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not delete queue group', theme: 'error'})
        });
      });
    },
    openItemGroupForm(item) {
      this.editItemGroup = Object.assign({}, item);
    },
    closeItemGroupForm() {
      this.editItemGroup = null;
      if (this.$refs.itemGroupForm) {
        this.$refs.itemGroupForm.reset();
      }
    },
    createNewItemGroup() {
      return {
        name: '',
        vat: ''
      };
    },
    openTabForm(item) {
      this.editTab = Object.assign({}, item);
    },
    closeTabForm() {
      this.editTab = null;
      if (this.$refs.tabForm) {
        this.$refs.tabForm.reset();
      }
    },
    createNewTab() {
      return {
        name: '',
        order: this.getNextOrderNumber(this.sortedTabs)
      };
    },
    openQueueGroupForm(item) {
      this.editQueueGroup = Object.assign({}, item);
    },
    closeQueueGroupForm() {
      this.editQueueGroup = null;
      if (this.$refs.queueGroupForm) {
        this.$refs.queueGroupForm.reset();
      }
    },
    createNewQueueGroup() {
      return {
        name: '',
        order: this.getNextOrderNumber(this.sortedQueueGroups)
      };
    }
  },
  components: {
    BaseItems,
    draggable,
    ItemGroupForm,
    TabForm,
    QueueGroupForm
  }
}
</script>

<style>
.tab-ghost {
  background: var(--v-secondary-base);
}
.queuegroup-ghost {
  background: var(--v-secondary-base);
}
</style>

<style lang="css" scoped>
.itemgroups-table:deep tbody tr {
  cursor: pointer;
}

.itemgroups-table:deep td:last-of-type,
.itemgroups-table:deep th:last-of-type {
    width: 100px;
    text-align: center !important;
}
.handle {
  cursor: grab;
}
</style>
